import { useState, useEffect } from 'react';
import useWindowDimensions from "../../hooks/useWindowDimensions";
import React from "react";


const Technologies = () => {

 const { height, width } = useWindowDimensions();
 if(width){

 }
    const customProgress = {
        progressBackground: {
            background: "#162950",
            margin: "15px 0",
        },
        gradient: {
            background: "linear-gradient(270deg, #13ADC7 0%, #6978D1 66.67%, #945DD6 100%)",
            borderRadius: "10px"
        },
        label: {
            fontWeight: "500",
            fontSize:(width >= "1024" ? "28px":"20px"),
            lineHeight:"50px"
        }
    }


    const skillsSet = [
        {
            skillName: "Html",
            parcentage: "80%"
        },
        {
            skillName: "CSS, Sass, Bootstrap & Mui Design",
            parcentage: "75%"
        },
        {
            skillName: "JavaScript, JQuery",
            parcentage: "75%"
        },
        {
            skillName: "UI design in Figma",
            parcentage: "60%"
        },
        {
            skillName: "React, Next js",
            parcentage: "80%"
        },
        {
            skillName: "NPM, Yarn",
            parcentage: "70%"
        },
        {
            skillName: "Github",
            parcentage: "70%"
        },
    ];
    const tpm = customProgress.gradient;
    return (
        <div className={"brijesh_wrapper p-0"}>
            <div className={"container section_title_main project_wrapper pt-0 mt-4"} id={"technologies"}>
                <h3 className={"section_title  mt-0 pt-0 pt-lg-5 mt-lg-5 mb-lg-5 mb-0"}>Technologies & Language</h3>
                <div className={"px-lg-4 px-0 mx-lg-4 mx-3"}>
                    {skillsSet.map((el) => {
                        return (
                            <>
                                <p style={customProgress.label}>{el.skillName}</p>
                                <div className="progress" style={customProgress.progressBackground}>
                                    <div className="progress-bar progress-bar-striped" role="progressbar"
                                         style={{...tpm, width: `${el.parcentage}`}}
                                         aria-valuenow="10" aria-valuemin="0" aria-valuemax="100"></div>
                                </div>
                            </>
                        )
                    })}

                    {/*<h4>width: {width} ~ height: {height}`</h4>*/}
                </div>
            </div>
        </div>
    )
}
export default Technologies;
